import { userAuth } from './userAuth';
import { supabaseAuth } from './supabaseAuth';

interface WhatsAppInitResponse {
  sessionToken: string;
  whatsappLink: string;
  prefillMessage: string;
  message?: string;
}

const PREFILL_MESSAGES: Record<string, string> = {
  en: 'Start my coaching',
  nl: 'Begin mijn coaching',
  ar: 'ابدأ تدريبي',
};

async function initWhatsAppCoaching(language: string = 'en'): Promise<WhatsAppInitResponse> {
  const user = userAuth.getCurrentUser();
  if (!user || user.isGuest) {
    throw new Error('User not authenticated');
  }

  const token = await supabaseAuth.getAccessToken();
  if (!token) {
    throw new Error('No access token available');
  }

  const response = await fetch('/api/whatsapp/init', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ language, prefillMessage: PREFILL_MESSAGES[language] || PREFILL_MESSAGES.en }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to initialize WhatsApp coaching');
  }

  return response.json();
}

async function pauseWhatsAppCoaching(): Promise<void> {
  const user = userAuth.getCurrentUser();
  if (!user || user.isGuest) {
    throw new Error('User not authenticated');
  }

  const token = await supabaseAuth.getAccessToken();
  if (!token) {
    throw new Error('No access token available');
  }

  const response = await fetch('/api/whatsapp/pause', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to pause WhatsApp coaching');
  }
}

async function resumeWhatsAppCoaching(): Promise<void> {
  const user = userAuth.getCurrentUser();
  if (!user || user.isGuest) {
    throw new Error('User not authenticated');
  }

  const token = await supabaseAuth.getAccessToken();
  if (!token) {
    throw new Error('No access token available');
  }

  const response = await fetch('/api/whatsapp/resume', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to resume WhatsApp coaching');
  }
}

export const whatsappCoachingService = {
  initWhatsAppCoaching,
  pauseWhatsAppCoaching,
  resumeWhatsAppCoaching,
};
